import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

//import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';

//import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DocViewerComponent } from './layout/doc-viewer/doc-viewer.component';
import { TopMenuComponent } from './layout/top-menu/top-menu.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ModeBannerComponent } from './layout/mode-banner/mode-banner.component';
import { NotificationComponent } from './layout/notification/notification.component';
import { SharedModule } from './shared/shared.module';
import { SearchBoxComponent } from './search/search-box/search-box.component';
import { NavMenuComponent } from './layout/nav-menu/nav-menu.component';
import { NavItemComponent } from './layout/nav-item/nav-item.component';
import { Deployment } from './shared/deployment.service';
import { DocumentService } from './documents/document.service';
import { Logger } from './shared/logger.service';
import { LocationService } from './shared/location.service';
import { GaService } from './shared/ga.service';
import { windowProvider, WindowToken } from './shared/window';
import { ScrollService } from './shared/scroll.service';
import { ScrollSpyService } from './shared/scroll-spy.service';
import { SearchService } from './search/search.service';
import { NavigationService } from './navigation/navigation.service';
import { TocService } from './shared/toc.service';
import { currentDateProvider, CurrentDateToken } from './shared/current-date';
import { CustomElementsModule } from './custom-elements/custom-elements.module';


@NgModule({ declarations: [
        AppComponent,
        DocViewerComponent,
        FooterComponent,
        ModeBannerComponent,
        NavMenuComponent,
        NavItemComponent,
        SearchBoxComponent,
        NotificationComponent,
        TopMenuComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        //AppRoutingModule,
        BrowserAnimationsModule,
        CustomElementsModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatSidenavModule,
        MatToolbarModule,
        SharedModule], providers: [
        Deployment,
        DocumentService,
        Logger,
        Location,
        LocationService,
        GaService,
        { provide: WindowToken, useFactory: windowProvider },
        NavigationService,
        ScrollService,
        ScrollSpyService,
        SearchService,
        TocService,
        { provide: CurrentDateToken, useFactory: currentDateProvider },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
